module.exports = __webpack_public_path__ + "static/media/phone-icon.fd9c2153.svg";